module.exports = __webpack_public_path__ + "img/cj_detail.e7d61966.jpg";